import axios from 'axios';

class ApiService {
  constructor(httpClient, apiUrl, enviromentServerUrl, requestTimeout, errorHandler, authStorageService) {
    this.httpClient = httpClient;
    // this.apiUrl = false;
    this.enviromentServerUrl = enviromentServerUrl;
    this.requestTimeout = requestTimeout;
    this.errorHandler = errorHandler;
    this.authStorageService = authStorageService;

    // (async () => {
    //   try {
    //     const response = await axios({
    //       url: `${enviromentServerUrl}/base-url`,
    //       timeout: requestTimeout
    //     });
    //     this.apiUrl = response.data.url || apiUrl;
    //   } catch (err) {
    //     this.apiUrl = apiUrl || window.location.origin;
    //     console.log('Get base url error - ', err);
    //     return null;
    //   }
    // })();

    // this.httpClient.interceptors.response.use(
    //   response => {
    //     return response;
    //   },
    //   error => {
    //     if (
    //       error &&
    //       error.request &&
    //       error.request.responseType === 'blob' &&
    //       error.response.data instanceof Blob &&
    //       error.response.data.type &&
    //       error.response.data.type.toLowerCase().indexOf('json') !== -1
    //     ) {
    //       return new Promise((resolve, reject) => {
    //         let reader = new FileReader();
    //         reader.onload = () => {
    //           error.response.data = JSON.parse(reader.result);
    //           resolve(Promise.reject(error));
    //         };

    //         reader.onerror = () => {
    //           reject(error);
    //         };

    //         reader.readAsText(error.response.data);
    //       });
    //     }

    //     return Promise.reject(error);
    //   }
    // );
  }

  get(url, params) {
    return this.httpClient
      .get(url, {
        params: params,
        timeout: this.requestTimeout,
        headers: this.buildHeaders()
      })
      .then(this.onSuccess)
      .catch(this.errorHandler.handle);
  }

  post(url, data, options = null) {
    return this.httpClient
      .post(url, data, {
        timeout: this.requestTimeout,
        headers: this.buildHeaders('POST', options ? options.headers : null)
      })
      .then(this.onSuccess)
      .catch(this.errorHandler.handle);
  }

  put(url, data, options = null) {
    return this.httpClient
      .put(url, data, {
        timeout: this.requestTimeout,
        headers: this.buildHeaders('PUT', options ? options.headers : null)
      })
      .then(this.onSuccess)
      .catch(this.errorHandler.handle);
  }

  patch(url, data) {
    return this.httpClient
      .patch(url, data, {
        timeout: this.requestTimeout,
        headers: this.buildHeaders()
      })
      .then(this.onSuccess)
      .catch(this.errorHandler.handle);
  }

  delete(url, params) {
    return this.httpClient
      .delete(url, {
        params: params,
        timeout: this.requestTimeout,
        headers: this.buildHeaders()
      })
      .then(this.onSuccess)
      .catch(this.errorHandler.handle);
  }

  upload(url, formData) {
    return this.httpClient
      .post(url, formData, {
        timeout: this.requestTimeout,
        headers: this.buildHeaders('POST', {
          'Content-Type': 'multipart/form-data'
        })
      })
      .then(this.onSuccess)
      .catch(this.errorHandler.handle);
  }

  uploadMultiple(url, formData) {
    return this.httpClient
      .post(url, formData, {
        timeout: this.requestTimeout,
        headers: this.buildHeaders('POST', {
          'Content-Type': 'undefined'
        })
      })
      .then(this.onSuccess)
      .catch(this.errorHandler.handle);
  }

  download(url, filename) {
    return this.httpClient({
      url,
      method: 'GET',
      responseType: 'blob',
      headers: this.buildHeaders('GET')
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch(this.errorHandler.handle);
  }

  // getFullUrl(url) {
  //   return `${this.apiUrl}${url}`;
  // }

  onSuccess(response) {
    return response;
  }

  buildHeaders(method, customHeaders = null) {
    const headers = {};

    if (method === 'POST' || method === 'PUT') {
      headers['Content-Type'] = 'application/json';
    }

    if (this.authStorageService.isAuthenticated()) {
      const auth = this.authStorageService.getAuth();
      headers['Authorization'] = `${auth.token_type} ${auth.access_token}`;
    }

    if (customHeaders) {
      Object.keys(customHeaders).forEach(key => {
        headers[key] = customHeaders[key];
      });
    }

    return headers;
  }
}

export default ApiService;
